import { render, staticRenderFns } from "./text-with-tooltip.vue?vue&type=template&id=067a4c47&scoped=true&"
import script from "./text-with-tooltip.vue?vue&type=script&lang=js&"
export * from "./text-with-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./text-with-tooltip.vue?vue&type=style&index=0&id=067a4c47&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a4c47",
  null
  
)

export default component.exports